import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';

export const fetchOCClaimEmailNotifications = createProvider(api.fetchClaimEmailNotifications)
  .andThen((res) => res)
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch claim email notifications aborted');
    } else {
      console.error('Fetch claim email notifications failed:', error);
    }
    throw error;
  });

export const sendOCClaimPdfToCarrierProvider = createProvider(api.sendOCClaimPdfToCarrier)
  .andThen((res) => res)
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Send OC claim PDF to carrier aborted');
    } else {
      console.error('Send OC claim PDF to carrier failed:', error);
    }
    throw error;
  });
